import React from 'react'
import { Autocomplete, createFilterOptions, TextField } from '@mui/material'

const filterOptions = createFilterOptions({
  matchFrom: 'start',
  stringify: (option) => option.label
})

const Menu = ({ value: currentValue, onChange, languages, width = 438, isLoading }) => (
  <Autocomplete
    id='article-translate-autocomplete'
    sx={{ maxWidth: width }}
    disabled={isLoading}
    fullWidth
    value={currentValue}
    options={languages}
    getOptionLabel={option => `${option.translatedLabel} (${option.label})`}
    filterOptions={filterOptions}
    onChange={(_event, newValue) => onChange(newValue)}
    renderInput={params => (
      <TextField
        {...params}
        margin='dense'
        label='Language'
        inputProps={{ ...params.inputProps, 'data-test': 'article-translate-selector' }}
        SelectProps={{ SelectDisplayProps: { 'data-test': 'article-translate-menu' } }}
      />
    )}
  />
)

export default Menu
